import { FC } from "react";
import { Navbar } from "./Navbar";
import styled from "styled-components";
import GeneralModal from "common/base/Modal";
import BasicModal from "common/base/modals/basic-modal";
import { Outlet } from "react-router-dom";
import { useAuth } from "hooks";
import { routeNames } from "utils";

const Root = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: #fff;
`;
const Body = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - 70px);
`;

export interface AdminDashboardLayoutProps {
}

export const AdminDashboardLayout: FC<AdminDashboardLayoutProps> = ({

}) => {
  const { logout } = useAuth();
  return (
    <Root>
      <Navbar {...{
        onLogout() {
          logout(routeNames.adminLogin);
        },
      }}/>
      <Body>
        <Outlet/>
      </Body>
      <GeneralModal/>
      <BasicModal/>
    </Root>
  );
};
